module.exports = __webpack_public_path__ + "static/media/hygiene-checklist.1d1c2a6d.png";